export default "__VITE_ASSET__Dzsm9D8l__"